// extracted by mini-css-extract-plugin
export default {"pageContent":"AdminRoutes_pageContent__K727a","pageContentBox":"AdminRoutes_pageContentBox__octpL"};